module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.23719/images/biz-card-header-pattern.png"